import React, { useContext, useEffect } from "react";
import { Spinner, Flex } from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import AuthContext from "../Utils/auth";
import { checkPaymentTokenAPI } from "../Utils/api";

const PaymentAuth = () => {
  const navigate = useNavigate();
  const { encodedUrl, campaign } = useParams();
  const authCtx = useContext(AuthContext);
  useEffect(() => {
    const checkPaymentTokenAndRedirect = async () => {
      try {
        const { data } = await checkPaymentTokenAPI(campaign, encodedUrl);
        const { type, token, email, name } = data;
        if (type === "login" || type === "signup") {
          authCtx.login(token, email, name);
          navigate("/", { state: { parameter: "start" } });
        } else {
          navigate("/error");
        }
      } catch (error) {
        console.error("Error:", error);
        navigate("/error");
      }
    };

    checkPaymentTokenAndRedirect();
  }, [navigate, authCtx]);

  return (
    <Flex flexDir="column" h="100vh">
      <Spinner m="auto" size="xl" />
    </Flex>
  );
};

export default PaymentAuth;
